var _style, _path, _g, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetabolicSyndrome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004137;}\n\t.st1{fill:#E6393D;}\n\t.st2{fill:none;stroke:#F8EEE1;stroke-width:4.9435;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.4,94.6C151.3,80.9,141,70,128.5,70.1c-12.5,0.1-22.5,11.3-22.3,25c-0.1-13.7-10.4-24.6-22.9-24.5 c-12.5,0.1-22.5,11.3-22.3,25c0,4.2,1.2,8.4,3,12.5c0,0.1,0,0.2,0,0.2c0,0.5,0.1,1,0.2,1.4c0,0,0,0,0,0c0,0,0,0.1,0,0.1 c0.3,1.4,1,2.5,1.9,3.4l-0.9,0c11.3,21.9,41.7,40.9,41.7,40.9s29.9-19.6,40.7-41.7l-1,0c0.8-1,1.4-2.2,1.5-3.9c0-0.1,0-0.1,0-0.2 l0.2,0C150.3,103.8,151.5,99.2,151.4,94.6z"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "56.2,111.2 85,110.6 89.3,98.9 101.3,130.6 109.4,104.6 114.1,117.6 122.6,103.4 125.8,115.3  127.7,110.8 152.3,111 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetabolicSyndrome);
export default __webpack_public_path__ + "static/media/Metabolic_Syndrome.ed139693858c971b782a61479cd0a9ff.svg";
export { ForwardRef as ReactComponent };